import * as T from 'prop-types';

import Banner from './banner';

const InformativeBanner = ({
  badgeColor,
  badgeLabel,
  borderColor,
  file,
  link,
  linkLabel,
  listItems,
  listLabel,
  loop,
  showBadgeIcon,
  subTitle,
  title,
}) => {
  return (
    <Banner file={file} loop={loop} borderColor={borderColor}>
      <Banner.Body
        title={title}
        subTitle={subTitle}
        badgeLabel={badgeLabel}
        badgeColor={badgeColor}
        showBadgeIcon={showBadgeIcon}
        linkLabel={linkLabel}
        link={link}
        listLabel={listLabel}
        listItems={listItems}
      />
    </Banner>
  );
};

InformativeBanner.propTypes = {
  file: T.shape({}).isRequired,
  title: T.node,
  subTitle: T.node,
  listItems: T.arrayOf(T.shape({ text: T.node.isRequired })),
  listLabel: T.node,
  link: T.string,
  badgeLabel: T.string,
  badgeColor: T.string,
  borderColor: T.string,
  showBadgeIcon: T.bool,
  linkLabel: T.string,
  loop: T.bool,
};

InformativeBanner.defaultProps = {
  title: '',
  subTitle: '',
  linkLabel: '',
  listItems: [],
  listLabel: '',
  link: '',
  loop: false,
  badgeLabel: '',
  badgeColor: '',
  borderColor: '',
  showBadgeIcon: false,
};

export default InformativeBanner;
